import React, {useState} from "react";
import {Row, Progress, Button, Spin, Typography, Tooltip} from "antd";
import {useTranslation} from "react-i18next";

import {useObserver} from "mobx-react-lite";
import {StatsIcon} from "../../_defaultComponents/Stats/StatsIcon";

import {
    Container,
    Value,
    SpinnerContainer,
    IconContainer,
    NoIcon,
    TextContainer,
    ProgressContainer,
    NumberInput
} from "./statsStyles";
import {mapStatisticTitles} from "../../../constants/constants";

export const Stats = ({item, loading, minute, setPercentage, type, progressLoading}) => {
    const {t} = useTranslation(["stats", "mapStatisticTitles"]);
    const [percentageMinTextFieldVisible, setPercentageMinTextFieldVisible] = useState(false);
    const [defaultValueMinute, setDefaultValueMinute] = useState(45);
    const icon = mapStatisticTitles[item[0]]?.icon;
    const progressColour = percentage => {
        if (percentage > 80) {
            return "green";
        } else if (percentage <= 80 && percentage > 60) {
            return "orange";
        } else {
            return "red";
        }
    };

    const {Text} = Typography;

    return useObserver(() => (
        <div data-testid="stats" data-testvalue="">
            <Container bodyStyle={{padding: "0"}} loading={type === "current" ? false : loading}>
                <Row
                    data-testid="statsHeader"
                    justify="space-between"
                    style={{marginBottom: "24px"}}
                >
                    <IconContainer>
                        {icon ? (
                            <StatsIcon statIconType={icon} data-testid="statsIcon" />
                        ) : (
                            <NoIcon />
                        )}
                    </IconContainer>

                    {item[0] === "percentage" ? (
                        progressLoading ? (
                            <SpinnerContainer>
                                <Spin spinning={progressLoading} />
                            </SpinnerContainer>
                        ) : (
                            <ProgressContainer>
                                <Progress
                                    data-testid="progress"
                                    strokeWidth={25}
                                    percent={parseInt(item[1])}
                                    strokeColor={progressColour(item[1])}
                                    width={80}
                                />
                            </ProgressContainer>
                        )
                    ) : (
                        <Tooltip title={item[1]}>
                            <Text
                                data-testid="value"
                                style={{
                                    alignContent: "space-around",
                                    maxWidth: "75%",
                                    color: "#283f6d",
                                    fontWeight: "bold",
                                    fontSize: "36px"
                                }}
                                ellipsis={true}
                            >
                                {item[1]}
                            </Text>
                        </Tooltip>
                    )}
                </Row>
                <Row data-testid="statsFooter">
                    {item[0] === "percentage" ? (
                        <Row align="middle">
                            {!percentageMinTextFieldVisible ? (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "baseline"
                                    }}
                                >
                                    <Button
                                        data-testid="minuteButton"
                                        style={{backgroundColor: "#edf1fc"}}
                                        type="text"
                                        onClick={() => {
                                            setPercentageMinTextFieldVisible(true);
                                        }}
                                    >
                                        {minute}
                                    </Button>
                                    <Text style={{fontSize: 12, marginLeft: "10px"}}>
                                        {t("stats.minutesInDelivered", {ns: "stats"})}
                                    </Text>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "baseline"
                                    }}
                                >
                                    <NumberInput
                                        data-testid="minuteInput"
                                        onBlur={e => {
                                            if (
                                                !Number(e.target.value) ||
                                                e.target.value.length === 0
                                            ) {
                                                return;
                                            }
                                            setPercentage(e.target.value);
                                            setPercentageMinTextFieldVisible(false);
                                            setDefaultValueMinute(e.target.value);
                                        }}
                                        type="number"
                                        inputMode="numeric"
                                        max={99}
                                        style={{width: "25%"}}
                                        defaultValue={defaultValueMinute}
                                    />
                                    <Text style={{fontSize: 12, marginLeft: "10px"}}>
                                        {t("stats.enterNewMinute", {ns: "stats"})}
                                    </Text>
                                </div>
                            )}
                        </Row>
                    ) : (
                        <TextContainer data-testid="footerText">
                            <Value color="black">
                                {t(mapStatisticTitles[item[0]]?.translation_key, {
                                    ns: "mapStatisticTitles"
                                })}
                            </Value>
                        </TextContainer>
                    )}
                </Row>
            </Container>
        </div>
    ));
};
